import hash from 'object-hash';

export const Endpoint = () => `/api/ui/audit/sbom`;
export const QueryKey = (payload: Payload) =>
    ['ui', 'audit', 'sbom', hash(payload, { algorithm: 'md5', unorderedArrays: true })] as const;
export type Payload = File;

export type Response = {
    package: string;
    version: string;
    fixed_version: string;
    scopes: string[];
    applicable_advisories: {
        id: string;
        type: string;
        match: string;
        title: string;
        description: string;
        published: Date;
        epss: {
            cve: string;
            epss: number;
            percentile: number;
            date: Date;
        }[];
        ai_score: {
            value: number;
            uncertainty: number;
        };
    }[];
}[];
